exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".labeled-link{display:flex;flex-flow:row wrap;padding-bottom:5px}.labeled-link .data-label{color:#aaa;margin-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/product/shared/components/labeled-link.scss
// module id = 5150
// module chunks = 0